
import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../components/ui/table";
import { useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function InspectionItemsTable() {
  const token = localStorage.getItem("token");
  const[inspectionItems, setInspectionItems] =useState <any[]>([]);
  const navigate = useNavigate();

  const fetchInspectionItems = async() => {
    const response = await fetch(`${apiUrl}/inspection_items`, {
      headers: {
        "Content-Type": "application/json",
        "token": token || "",
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    
    if (result.success) {
      setInspectionItems(result.inspectionItems);
    } else {
      setInspectionItems([]);
    }  
  }
  // Initial load
  useEffect(() => {
    fetchInspectionItems();
  }, []);

  const handleRowClick = (inspectionItem: any) => {
    navigate("/update-inspection-item", { state: { inspectionItem } });
  };

  return (
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Inspection Item Name
                  </span>
                </div>
              </div>
            </TableCell>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Heading
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {inspectionItems.map((inspectionItem) => (
            <TableRow key={inspectionItem.inspectiontask_id} className="cursor-pointer hover:bg-[#ffffa3]" onClick={() => handleRowClick(inspectionItem)}>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{inspectionItem.inspectionitem_name}</span>
              </TableCell>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{inspectionItem.heading_name}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>  
    </>
  );
}